<template>
  <div style="width: 100%;height: 100%">
    <div class="title-top-alarm">
      <div>
        <span>客服回访</span>
      </div>
      <div class="line-title"></div>
    </div>
    <div style="height: 40px;width: 100%;margin: 0 40px">
      <div :class="item.index === indexActive ? 'select-active' : 'no-select'" v-for="(item, idx) in tabs" :key="idx" @click="selectTab(item)">
        <span>{{item.name}}</span>
      </div>
    </div>
    <div v-if="indexActive === 0">
      <div> <!--电话列-->
        <call-phone-out v-if="phone1 && phone2" :phoneOut="callPhone" @fatherEvent="fatherEvent"></call-phone-out>
      </div>
      <div style="margin: 20px 0">
        <service-object-alarm :serviceObj="serviceObj" @handleAlarm="getPersonNew"></service-object-alarm>
        <div style="height: 1px;background-color: #ebebeb;"></div>
        <div style="margin: 15px 50px 0">
          <el-row>
            <el-col :span="8">
              <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;派&nbsp;&nbsp;单：</span>
              <el-cascader v-fixZoom style="width: 260px" v-model="showid" placeholder="请选择" :options="typeEndTree" :props="propType"
              filterable change-on-select clearable ref="stidData" @change="getStidImgNew">
                <template #default="{data}">
                  <span v-if="data.noSelect" style="font-style: italic;color: #999999">{{ data.showName}}</span><strong v-else style="color: #1a1a1a;">{{ data.showName}}</strong>
                </template>
              </el-cascader>
            </el-col>
            <el-col :span="8">
              <div style="float: left;width: 75px;margin-left: 20px">
                回访记录：
              </div>
              <div style="float: left;width: calc(100% - 95px)">
                <el-input style="width: 100%" type="textarea" :rows="2" placeholder="请输入事件处理备注" v-model="showRemark"></el-input>
              </div>
              <div style="clear: both"></div>
            </el-col>
            <el-col :span="8">
              <span>&nbsp;&nbsp;&nbsp;转让外勤客服：</span>
              <el-select v-fixZoom style="width: 260px" v-model="csdId" placeholder="请选择" @change="sendCsd">
                <el-option v-for="item in orgpersons" :key="item.id" :label="item.nameShow" :value="item.id">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </div>
      </div>
      <div style="height:50px;margin-top: 10px;margin-right: 60px">
        <div style="float: right;">
          <div class="send-btn" @click="cancelOpen()">
            <span>呼叫结束</span>
          </div>
        </div>
        <div v-if="baseUrl !== 'jialod.com'" style="float: right;margin-right: 10px">
          <div class="send-btn-down" @click="downOrder(1)">
            <i class="el-icon-download"></i>
            <span>辅助就医</span>
          </div>
        </div>
        <div v-if="baseUrl !== 'jialod.com'" style="float: right;margin-right: 10px">
          <div class="send-btn-down" @click="downOrder(2)">
            &nbsp;&nbsp;<i class="el-icon-download"></i>
            <span>居家探访和代理服务</span>&nbsp;&nbsp;
          </div>
        </div>
        <div v-if="baseUrl !== 'jialod.com'" style="float: right;margin-right: 10px">
          <div class="send-btn-down" @click="downOrder(3)">
            &nbsp;&nbsp;<i class="el-icon-download"></i>
            <span>住院出院反馈表</span>&nbsp;&nbsp;
          </div>
        </div>
      </div>
    </div>
    <div v-if="indexActive === 1" style="margin: 0 50px">
      <el-table
        :data="showTable"
        size="mini"
        border
        style="width: 100%"
        highlight-current-row
        ref="singleTable">
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center">
        </el-table-column>
        <el-table-column
          prop="sp_name"
          label="客服人员"
          min-width="120"
          align="center">
        </el-table-column>
        <el-table-column
          prop="remarktime"
          label="回访时间"
          min-width="120"
          align="center">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="回访记录"
          min-width="150"
          align="center">
        </el-table-column>
      </el-table>
      <div style="margin-top: 10px;height:40px;text-align: center">
        <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="currentPage" :page-sizes="[10]" :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="totalCells">
        </el-pagination>
      </div>
    </div>
    <div v-if="indexActive === 2">
      <home-details :homeObj="homeObj"></home-details>
      <div style="height: 20px"></div>
    </div>
    <div v-if="indexActive === 3" style="margin: 0 30px">
      <device-details :deviceObj="deviceObj"></device-details>
    </div>
  </div>
</template>

<script>
import {sipphonecallend, addlaweralarminfo} from '../../../api/serviceObject'
import {sendSub} from '../../../mq'
import serviceObjectAlarm from '../../handlealarm/childComponents/serviceObjectAlarm'
import {
  queryphonebypid,
  queryphonebyhid,
  queryhomebyhids,
  queryoldpersonbyhids,
  hanlealarm, queryorgpersonuser
} from '../../../api/handlealarm'
import {makePhoneCall} from '../../../sip/sip_index'
import callPhoneOut from '../../handlealarm/childComponents/callPhoneOut'
import {querycalllistremarkbypid} from '../../../api/custormservice'
import homeDetails from '../../statisticalform/childComponents/homeDetails'
import deviceDetails from '../../datamanagement/quick/components/deviceDetails'
import {
  querysupplierservice,
  querysupplierorgnotype,
  querysuppliertype
} from '../../../api/serviceMark'
import {querydiseasename} from '../../../api/home'
export default {
  name: 'callPhonePage',
  components: {serviceObjectAlarm, callPhoneOut, homeDetails, deviceDetails},
  model: {
    prop: 'callPhoneShow',
    event: 'change'
  },
  props: {
    callPhoneRow: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      tabs: [
        {index: 0, name: '基础信息'},
        {index: 1, name: '回访记录'},
        {index: 2, name: '家庭信息'},
        {index: 3, name: '设备详情'}
      ],
      indexActive: 0,
      phone1: false,
      phone2: false,
      callPhone: {
        isAlarm: false,
        callPhoneObj: {},
        device_person: [], // 个人手表设备号码
        device_home: [], // 家庭网关设备号码
        person: [], // 个人号码/个人其它号码
        home: [], // 家庭号码/固话
        familyperson: [], // 家庭亲戚/联系人号码
        oldperson: ''
      },
      callPhoneObj: {},
      phones: {
        phone: '',
        telephone: '',
        ownphone: '',
        familyPhone: '',
        secondphone: ''
      },
      phonenum: '',
      showRemark: '',
      // 派单新
      supplierorgNew: [], // 服务商
      serviceData: [], // 服务内容
      orgData: [], // 组织
      showid: '',
      propType: { checkStrictly: true, value: 'showId', label: 'showName', children: 'child', emitPath: false, disabled: 'noSelect' },
      typeEndTree: [],
      allType: [],
      types: [], // 服务类型
      supplierorg: [], // 服务商
      stid: '',
      soid: '',
      options: [],
      newTypes: [],
      props1: { checkStrictly: true, value: 'id', label: 'showname', children: 'child', emitPath: false },

      isOrder: '',
      orders: [{id: 0, name: '不派单'}, {id: 1, name: '派单'}],
      beginTime: '',
      endTime: '',
      syspersonid: '',
      // 服务对象
      serviceObj: {
        projects: [],
        frequencys: [],
        oldperson: '',
        editOldPerson: '', // 客服关爱编辑生命体征
        isCallBack: true
      },
      phonepids: [],
      phonehids: [],
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      showTable: [],
      tableData: [],
      homeObj: {
        home: '',
        orgcommunitys: [],
        oldpersons: [] // 家庭联系人
      },
      deviceObj: { // 设备详情
        personId: '',
        hid: ''
      },
      csdId: '',
      orgpersons: [], // 外勤客服
      diseasenames: [],
      baseUrl: ''
    }
  },
  created () {
    this.baseUrl = window.location.host
    this.getCsd()
    this.querySupplierNew()
    console.log(this.callPhoneRow)
    this.callPhoneObj = this.callPhoneRow.row
    this.callPhone.oldperson = this.callPhoneRow.row
    this.callPhone.callPhoneObj = this.callPhoneRow.row
    this.phones.phone = this.callPhoneObj.phone
    this.syspersonid = this.$store.state.user.syspersonid
    this.homeObj.orgcommunitys = this.callPhoneRow.orgcommunitys
    this.serviceObj.projects = this.callPhoneRow.projects
    this.serviceObj.frequencys = this.callPhoneRow.frequencys
    this.serviceObj.oldperson = this.callPhoneRow.row
    this.serviceObj.editOldPerson = this.callPhoneRow.row
    this.phonepids.push(this.callPhoneRow.row.id)
    this.phonehids.push(this.callPhoneRow.row.homeid)
    this.deviceObj.hid = this.callPhoneRow.row.homeid
    this.orgData = this.callPhoneRow.orgData
    this.getHomeData()
    this.getOldPersonByHome()
    this.getRemarkHistory()
    this.getPhoneByPerson()
    this.getPhoneByHome()
    this.getDisease()
  },
  mounted () {
  },
  methods: {
    // 获取客服
    getCsd () {
      let syspersonid = this.$store.state.user.syspersonid
      queryorgpersonuser().then(res => {
        let arr = res.data.orgpersons
        let list = []
        for (let i = 0; i < arr.length; i++) {
          if (syspersonid !== arr[i].id) {
            let obj = arr[i]
            obj.nameShow = arr[i].name + ' — ' + arr[i].jobnum
            list.push(obj)
            this.orgpersons.push(obj)
          }
        }
        console.log('外勤', this.orgpersons)
      }).catch(() => {})
    },
    getPersonNew (person) {
      this.serviceObj.editOldPerson = person
    },
    // 服务商
    querySupplierNew () {
      let params = {
        page: 1,
        size: 9999
      }
      querysupplierorgnotype(params).then(res => {
        this.supplierorgNew = res.data.org
        this.querySupplierType()
      }).catch(() => {})
    },
    // 服务类型
    querySupplierType () {
      let params = {
        page: 1,
        size: 99999
      }
      let data = {
        orgid: []
      }
      querysuppliertype(params, data).then(res => {
        this.types = res.data.types
        this.getServiceContent()
      }).catch(() => {})
    },
    // 服务内容
    getServiceContent () {
      let params = {
        page: 1,
        size: 99999
      }
      querysupplierservice(params).then(res => {
        this.serviceData = res.data.service
        let obj = this.commonType.getNewPaidan(this.orgData, this.supplierorgNew, this.types, this.serviceData)
        this.typeEndTree = obj.tree
        this.allType = obj.allArr
      }).catch(() => {})
    },
    selectTab (item) {
      this.indexActive = item.index
    },
    // 派单
    getStidImgNew (showId) {
      this.allType.forEach(item => {
        if (item.showId === showId) {
          console.log(item.st_id, item.so_id)
          this.stid = item.st_id
          this.soid = item.so_id
        }
      })
    },
    // 家信息
    getHomeData () {
      let data = {
        hids: [this.callPhoneRow.row.homeid]
      }
      queryhomebyhids(data).then(res => {
        if (res.data.homes.length > 0) {
          this.homeObj.home = res.data.homes[0]
        }
      }).catch(() => {})
    },
    // 家庭查家庭成员 （服务对象信息 默认第一个）
    getOldPersonByHome () {
      let data = {
        hids: [this.callPhoneRow.row.homeid]
      }
      queryoldpersonbyhids(data).then(res => {
        this.homeObj.oldpersons = res.data.persons // 家庭详细中家庭成员
      }).catch(() => {})
    },
    // 获取回访记录
    getRemarkHistory () {
      let data = {
        pid: this.callPhoneRow.row.id
      }
      querycalllistremarkbypid(data).then(res => {
        this.tableData = res.data.callremarklist
        this.totalCells = this.tableData.length
        this.showTable = this.tableData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
      }).catch(() => {})
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.showTable = this.tableData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
    },
    handleCurrentChange (val) {
      this.currentPage = val
      this.showTable = this.tableData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize)
    },
    // 获取电话按钮数据
    getPhoneByPerson () {
      let data = {
        pids: this.phonepids
      }
      queryphonebypid(data).then(res => {
        for (let i = 0; i < res.data.phones.length; i++) {
          if (res.data.phones[i].phonetype === 1) {
            if (res.data.phones[i].phone) {
              this.callPhone.device_person.push(res.data.phones[i])
            }
          } else if (res.data.phones[i].phonetype === 2) {
            if (res.data.phones[i].phone) {
              this.callPhone.device_home.push(res.data.phones[i])
            }
          } else if (res.data.phones[i].phonetype === 4 || res.data.phones[i].phonetype === 16) { // 个人号码  其他号码
            if (res.data.phones[i].phone) {
              this.callPhone.person.push(res.data.phones[i])
            }
          } else if (res.data.phones[i].phonetype === 8) {
            if (res.data.phones[i].phone) {
              this.callPhone.home.push(res.data.phones[i])
            }
          } else if (res.data.phones[i].phonetype === 32) {
            if (res.data.phones[i].phone) {
              this.callPhone.familyperson.push(res.data.phones[i])
            }
          }
        }
        this.phone1 = true
      }).catch(() => {})
    },
    getPhoneByHome () {
      let data = {
        hids: this.phonehids
      }
      queryphonebyhid(data).then(res => {
        for (let i = 0; i < res.data.phones.length; i++) {
          if (res.data.phones[i].phonetype === 1) {
            if (res.data.phones[i].phone) {
              this.callPhone.device_person.push(res.data.phones[i])
            }
          } else if (res.data.phones[i].phonetype === 2) {
            if (res.data.phones[i].phone) {
              this.callPhone.device_home.push(res.data.phones[i])
            }
          } else if (res.data.phones[i].phonetype === 4 || res.data.phones[i].phonetype === 16) { // 个人号码  其他号码
            if (res.data.phones[i].phone) {
              this.callPhone.person.push(res.data.phones[i])
            }
          } else if (res.data.phones[i].phonetype === 8) {
            if (res.data.phones[i].phone) {
              this.callPhone.home.push(res.data.phones[i])
            }
          } else if (res.data.phones[i].phonetype === 32) {
            if (res.data.phones[i].phone) {
              this.callPhone.familyperson.push(res.data.phones[i])
            }
          }
        }
        this.phone2 = true
      }).catch(() => {})
    },
    editCallPhone (phoneNum) {
      if (phoneNum.slice(0, 3) === '021') {
        return
      }
      this.phonenum = phoneNum
      let name = this.$store.state.user.personname
      // eslint-disable-next-line no-extend-native
      Date.prototype.format = this.validate.format
      const date = new Date().format('hh:mm:ss')
      let dohandle = {id: this.callPhoneObj.id, name: name, time: date}
      let mqtts = this.$store.state.user.mqtts
      sendSub('callphone' + mqtts[0], JSON.stringify(dohandle))
      makePhoneCall(phoneNum)
      this.beginTime = date
    },
    fatherEvent (obj) {
      if (obj.type === 'call') {
        this.phonenum = obj.phoneNum
      }
    },
    getProjectName () {
      let row = this.callPhoneObj
      for (let i = 0; i < this.callPhoneRow.projects.length; i++) {
        if (row.projectid === this.callPhoneRow.projects[i].id) {
          return this.callPhoneRow.projects[i].projectname
        }
      }
    },
    getFrequencyName () {
      let row = this.callPhoneObj
      for (let i = 0; i < this.callPhoneRow.frequencys.length; i++) {
        if (row.frequencyid === this.callPhoneRow.frequencys[i].id) {
          return this.callPhoneRow.frequencys[i].frequency
        }
      }
    },
    cancelOpen () {
      // eslint-disable-next-line no-extend-native
      Date.prototype.format = this.validate.format
      const date = new Date().format('yyyy-MM-dd hh:mm:ss')
      this.endTime = date
      let sessionid = ''
      let arr = this.store2.state.other.callOut
      // console.log(arr)
      for (let i = 0; i < arr.length; i++) {
        if (this.phonenum === arr[i].phone) {
          sessionid = arr[i].sessionid
        }
      }
      let data = {
        sessionid: sessionid,
        sp_id: this.syspersonid,
        pid: this.callPhoneObj.id,
        phonenum: this.phonenum,
        begin_time: this.beginTime,
        end_time: this.endTime,
        remark: this.showRemark,
        is_order: ''
      }
      if (this.stid === '') {
        data.is_order = 0
      } else {
        data.is_order = 1
      }
      sipphonecallend(data).then(res => {
        if (data.is_order === 1) {
          this.doHanldeAlarmCall(res.data)
        }
        this.store2.dispatch('other/update_del_call_out', this.phonenum).then(() => {})
        let name = this.$store.state.user.personname
        // eslint-disable-next-line no-extend-native
        Date.prototype.format = this.validate.format
        const date = new Date().format('hh:mm:ss')
        let dohandle = {id: this.callPhoneObj.id, name: name, time: date}
        let mqtts = this.$store.state.user.mqtts
        sendSub('callphonedone' + mqtts[0], JSON.stringify(dohandle))
        this.$emit('change', false)
      }).catch(() => {})
    },
    // 派单处理接口
    doHanldeAlarmCall (alarmid) {
      if (!alarmid) {
        return
      }
      let data = {
        aid: alarmid,
        so_id: this.soid,
        st_id: this.stid,
        content: this.showRemark,
        pid: this.callPhoneRow.row.id,
        hid: this.callPhoneRow.row.homeid
      }
      hanlealarm(data).then(res => {
        let mqtts = this.$store.state.user.mqtts
        let name = this.$store.state.user.personname
        let dohandle = {id: this.alarmid, name: name}
        sendSub('/handledone' + mqtts[0], JSON.stringify(dohandle))
        this.store2.dispatch('other/update_del_alarm', this.alarmid).then(() => {
          if (this.$route.path === '/handleAlarm') {
            this.golobleObject.updateTableAlarm()
          }
        })
        let obj = {type: 'close'}
        this.$emit('getFatherHandle', obj)
      }).catch(() => {})
    },
    // 转让外勤客服
    sendCsd (id) {
      // console.log(id, this.orgpersons)
      for (let i = 0; i < this.orgpersons.length; i++) {
        if (id === this.orgpersons[i].id) {
          // console.log(this.orgpersons[i])
          this.$confirm('此操作将转让外勤客服【' + this.orgpersons[i].nameShow + '】, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            let data = {
              pid: this.callPhoneRow.row.id,
              hid: this.callPhoneRow.row.homeid,
              mine_uid: this.$store.state.user.sipinfo === '' ? 0 : this.$store.state.user.sipinfo.id, // 当前客服id
              other_uid: id, // 外勤客服id
              infotype: 3 // 默认3
            }
            addlaweralarminfo(data).then(res => {
              this.$notify({
                title: '成功',
                message: '成功转让外勤客服',
                type: 'success',
                duration: 2000
              })
              let obj = {type: 'close'}
              this.$emit('getFatherHandle', obj)
            }).catch(() => {})
          }).catch(() => {
            this.csdId = ''
          })
        }
      }
    },
    // 辅助就医
    downOrder (val) {
      if (val === 1) {
        // oldperson
        let obj = {
          areaAddress: '',
          areaCode: '',
          userNane: this.serviceObj.oldperson.name,
          userPhone: this.serviceObj.oldperson.phone,
          userIDcard: this.serviceObj.oldperson.idcard_num,
          userHealth: this.getHealth(),
          csdName: '',
          csdPhone: '',
          userAddress: '',
          blackAddress: '',
          doorTime: '',
          department: this.getDepartment()
        }
        this.exceljs.gotoexcel(obj)
      } else if (val === 2) {
        this.exceljs.goVisitExcel()
      } else if (val === 3) {
        this.exceljs.goHospitalExcel()
      }
    },
    // 患病类型
    getDisease () {
      querydiseasename().then(res => {
        this.diseasenames = res.data.diseasenames
      }).catch(() => {})
    },
    getHealth () {
      // categoryname
      let name = ''
      console.log(this.serviceObj.oldperson.have_disease, this.diseasenames)
      if (this.serviceObj.oldperson.have_disease !== '') {
        // let a = ','
        let arr = []
        let disease = this.serviceObj.oldperson.have_disease + ''
        arr = disease.split(',')
        for (let i = 0; i < arr.length; i++) {
          for (let j = 0; j < this.diseasenames.length; j++) {
            if (parseInt(arr[i]) === this.diseasenames[j].id) {
              if (name === '') {
                name = this.diseasenames[i].name
              } else {
                name = name + ',' + this.diseasenames[i].name
              }
            }
          }
        }
      }
      if (this.serviceObj.oldperson.input_disease !== '') {
        name = name + ',' + this.serviceObj.oldperson.input_disease
      }
      return name
    },
    getDepartment () {
      if (this.serviceObj.oldperson.have_disease === '') {
        return ''
      } else {
        let categoryname = ''
        let arr = this.serviceObj.oldperson.have_disease.split(',')
        for (let i = 0; i < arr.length; i++) {
          for (let j = 0; j < this.diseasenames.length; j++) {
            if (parseInt(arr[i]) === this.diseasenames[j].id) {
              if (name === '') {
                categoryname = this.diseasenames[i].name
              } else {
                if (categoryname.indexOf(this.diseasenames[i].categoryname) === -1) {
                  categoryname = categoryname + ',' + this.diseasenames[i].categoryname
                }
              }
            }
          }
        }
        return categoryname
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/customerservice/childComponents/callPhonePage.vue